import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can sync data from LinkedIn Ads reports by configuring it as a source in PostHog. The supported reports that can be synced include Account, Campaigns, Campaign Stats, Campaign Groups and Campaign Groups Stats, as described here:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://learn.microsoft.com/en-us/linkedin/marketing/integrations/ads/account-structure/create-and-manage-accounts?view=li-lms-2025-08&tabs=http"
        }}>{`Accounts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://learn.microsoft.com/en-us/linkedin/marketing/integrations/ads/account-structure/create-and-manage-campaigns?view=li-lms-2025-08&viewFallbackFrom=li-lms-2023-05&tabs=http#search-for-campaigns"
        }}>{`Campaigns`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://learn.microsoft.com/en-us/linkedin/marketing/integrations/ads/account-structure/create-and-manage-campaign-groups?view=li-lms-2025-08&viewFallbackFrom=li-lms-2023-05&tabs=http#search-for-campaign-groups"
        }}>{`Campaign Groups`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://learn.microsoft.com/en-us/linkedin/marketing/integrations/ads-reporting/ads-reporting?view=li-lms-2025-08&viewFallbackFrom=li-lms-2023-05&tabs=curl#ad-analytics"
        }}>{`Campaign Stats`}</a>{`: Ad analytics by CAMPAIGN`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://learn.microsoft.com/en-us/linkedin/marketing/integrations/ads-reporting/ads-reporting?view=li-lms-2025-08&viewFallbackFrom=li-lms-2023-05&tabs=curl#ad-analytics"
        }}>{`Campaign Group Stats`}</a>{`: Ad analytics by CAMPAIGN_GROUP`}</li>
    </ul>
    <p>{`Additional reports will be added based on user feedback we receive via our `}<a parentName="p" {...{
        "href": "https://app.posthog.com/#panel=support%3Afeedback%3Adata_warehouse%3Alow%3Atrue"
      }}>{`in-app support form`}</a>{`.`}</p>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`A LinkedIn Ads account with permission to access data from accounts you want to sync.`}</li>
      <li parentName="ul">{`Your account ID from the campaign manager (see how in the image below, it can also be taken from the URL like `}<inlineCode parentName="li">{`https://www.linkedin.com/campaignmanager/accounts/(ID here)/overview?businessId=personal`}</inlineCode>{`)`}</li>
    </ul>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/Screenshot_2025_09_04_at_5_12_47_PM_073654a608.png" classes="rounded" alt="LinkedIn account ID" mdxType="ProductScreenshot" />
    <h2 {...{
      "id": "configuring-posthog"
    }}>{`Configuring PostHog`}</h2>
    <p>{`Connect PostHog to your LinkedIn Ads account using a LinkedIn account. The LinkedIn account must have permission to access data.`}</p>
    <ol>
      <li parentName="ol">{`In PostHog, go to the `}<strong parentName="li"><a parentName="strong" {...{
            "href": "https://app.posthog.com/pipeline/sources"
          }}>{`Data pipelines`}</a></strong>{` tab.`}</li>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`+ New`}</strong>{` drop-down menu in the top-right and select `}<strong parentName="li">{`Source`}</strong>{`.`}</li>
      <li parentName="ol">{`Find LinkedIn Ads in the sources list and click `}<strong parentName="li">{`Link`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter the `}<strong parentName="li">{`Account ID`}</strong>{` of the LinkedIn Ads account you want to sync.`}</li>
      <li parentName="ol">{`Select an existing LinkedIn Ads account, or create a new integration`}</li>
      <li parentName="ol">{`(Optional) Add a prefix for the table name.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      